export const menu = () => {
  const menu = document.querySelector(".js-menu");
  const menuBtn = document.querySelector(".js-menu-btn");

  menuBtn.addEventListener("click", () => {
    menu.classList.toggle("is-open");
    menuBtn.classList.toggle("is-open");
  });
};
